import { Grid, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FilterProvider, Filter } from "@/partner/shared/components/Filter";
import { FilterTabs } from "@/partner/shared/components/FilterTabs";
import { LazyAnalyticsWidget } from "@/partner/shared/components/LazyAnalyticsWidget";
import { getAnalyticsTabs } from "./analyticsTabs";
import { AnalyticsUsersMetrics } from "./AnalyticsUsersMetrics";
import { AnalyticsUsersByDateChart } from "./AnalyticsUsersByDateChart";
import { AnalyticsUsersByCountryMap } from "./AnalyticsUsersByCountryMap";
import { AnalyticsUsersByCountryTable } from "./AnalyticsUsersByCountryTable";
import { AnalyticsUsersByLanguageTable } from "./AnalyticsUsersByLanguageTable";
import { AnalyticsUsersByLinkTable } from "./AnalyticsUsersByLinkTable";
import { AnalyticsUsersByEmailCampaignTable } from "./AnalyticsUsersByEmailCampaignTable";
import { AnalyticsUsersByUtmTable } from "./AnalyticsUsersByUtmTable";

function AnalyticsUsersTabContent() {
  const { t } = useTranslation();

  return (
    <Stack spacing={1}>
      <Filter
        title={t("analytics.pageTitle")}
        dateChips="RELATIVE"
        fields={{
          countryCodes: true,
          languages: true,
          dateFrom: true,
          dateTo: true,
          linkIds: true,
          utmSources: true,
          utmMediums: true,
          utmCampaigns: true,
          utmContents: true,
          utmTerms: true,
          emailAutomationIds: true,
        }}
      />

      <FilterTabs value="users" tabs={getAnalyticsTabs(t)} />

      <AnalyticsUsersMetrics />

      <Grid container spacing={1}>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsUsersByDateChart />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsUsersByCountryMap />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsUsersByCountryTable />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsUsersByLanguageTable />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsUsersByLinkTable />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsUsersByEmailCampaignTable />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsUsersByUtmTable
              dimension="SOURCE"
              title={t("analytics.users.tableByUtmSource")}
            />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsUsersByUtmTable
              dimension="MEDIUM"
              title={t("analytics.users.tableByUtmMedium")}
            />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsUsersByUtmTable
              dimension="CAMPAIGN"
              title={t("analytics.users.tableByUtmCampaign")}
            />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsUsersByUtmTable
              dimension="CONTENT"
              title={t("analytics.users.tableByUtmContent")}
            />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsUsersByUtmTable
              dimension="TERM"
              title={t("analytics.users.tableByUtmTerm")}
            />
          </LazyAnalyticsWidget>
        </Grid>
      </Grid>
    </Stack>
  );
}

export function AnalyticsUsersTab() {
  return (
    <FilterProvider initialPeriod="month">
      <AnalyticsUsersTabContent />
    </FilterProvider>
  );
}
